import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { getPrecision, getSeriesTooltipDot, getUnit } from "components/charts/utils";
import { getSeriesNameWithFormattedUwi } from "components/charts/utils/getSeriesNameWithFormattedUWI";

export function translateMaterialBalanceTooltipOptions(
  states: EvaChartStates
): TooltipOption {
  const { layout, hoverLegendItemRef } = states;

  const yAxisTitle = layout?.yAxis?.title || "";

  return {
    hideDelay: 0,
    trigger: "item",
    confine: true,
    className: "chart-tooltip-container",
    extraCssText: "border-style:none;",
    axisPointer: { type: "cross", label: { show: true, precision: 2 } },
    transitionDuration: 0, // prevent tooltip from flickering left to right on render
    formatter: function (items) {
      const series = Array.isArray(items)
        ? items.filter(
            (item) =>
              item.seriesName.startsWith(hoverLegendItemRef?.current) && item.value !== ""
          )[0]
        : items;
      if (series) {
        if (items.value?.length === 5) {
          return (
            `<span style="color:#666";>${getSeriesTooltipDot(
              series?.color !== "none" ? series.color : series?.borderColor
            )}${getSeriesNameWithFormattedUwi(series.seriesName)}</span>` +
            "<br/>" +
            `<p">${
              series.value[4] == 0 ? "" : series.value[4]
            }&emsp;<span style="font-weight:700;color:#666;float:right;font-family: var(--fontMono);";>${series.value[1].toFixed(
              getPrecision(getUnit(yAxisTitle))
            )}</span></p>`
          );
        }
      }
    }
  };
}
